const EMBLEM = "/brand/emblem_white.png";

const founders = [
  {
    name: "Kamel Jaber",
    role: "Founding Partner",
    bio: "20+ years in investment management and real estate across London and the Middle East. Has led capital deployment across cycles, with a focus on patient, asset-led strategies.",
  },
  {
    name: "Michael Chadburn",
    role: "Founding Partner",
    bio: "30+ years in real estate, primarily as a fund manager covering portfolios across the UK and Europe. Previously headed teams at ING Real Estate and BNP Paribas Real Estate.",
  },
  {
    name: "Jad Jaber",
    role: "Founding Partner",
    bio: "15+ years leading investment management and real estate development companies, with a strong track record across residential, commercial and industrial schemes.",
  },
];

const principles = [
  { n: "01", t: "Restoration", d: "We keep original fabric where we can and replace only what must be replaced. Additions are designed as additions — legible as new." },
  { n: "02", t: "Place before product", d: "The neighbourhood, the building, the people already using the space — these come first. The development brief is built around them." },
  { n: "03", t: "Community, after completion", d: "We build in dedicated spaces and ongoing programming so residents and the wider neighbourhood stay engaged with a project long after it's delivered." },
  { n: "04", t: "Roots down", d: "We prioritise local employment and local contractors, so that the economic benefit of a project stays with the place it's built in." },
  { n: "05", t: "Wider well-being", d: "Well-being for people and planet includes upholding best-in-class emissions and sustainability targets — as well as sourcing natural, non-toxic materials locally wherever possible." },
  { n: "06", t: "Local culture", d: "We empower the best of British culture, working with local creatives and businesses to continue a building's lineage through programming, partnerships, and design choices. We look for emerging talent in particular, and give them the platform to shine." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="hm-container pt-40 pb-24 md:pb-32">
        <div className="grid md:grid-cols-12 gap-12 items-end">
          <div className="md:col-span-12">
            <p className="hm-eyebrow mb-8">About Har-Monic</p>
            <h1 className="font-display leading-[0.98] tracking-[-0.02em]" style={{ fontSize: "clamp(44px, 6.4vw, 92px)", fontWeight: 400 }}>
              A development company that takes buildings — and the work — seriously.
            </h1>
          </div>
        </div>
        <div className="mt-12 max-w-3xl space-y-6 text-[17px] leading-relaxed text-[color:var(--hm-ink-dim)]">
          <p>
            Har-Monic is a London-based regenerative property development company. We restore heritage and vacant buildings into design-led residential, hospitality, and creative workspace projects. We sit at the intersection of architecture, culture, and place-making.
          </p>
          <p>
            Regeneration, to us, isn't limited to the building. A restored building is the starting point for rooting economic growth back into the neighbourhood around it — through the jobs it creates, the local businesses it works with, and the community it's built for. We give <span className="text-[color:var(--hm-ink)]">15% of profits to charity</span>, channelled to projects focused on education, nature, and alleviating poverty.
          </p>
        </div>
      </section>

      <section className="hm-paper py-28">
        <div className="hm-container">
          <p className="hm-eyebrow mb-6" style={{ color: "#5d5852" }}>Our approach</p>
          <h2 className="font-display max-w-4xl leading-[1.04] tracking-[-0.01em]" style={{ fontSize: "clamp(32px, 4.2vw, 60px)", fontWeight: 400, color: "#100c0a" }}>
            Regenerative development is a method.
          </h2>

          <div className="grid md:grid-cols-2 gap-12 mt-16">
            {principles.map((p) => (
              <div key={p.n} className="flex gap-6">
                <span className="font-display text-[42px] leading-none" style={{ color: "var(--hm-crimson)", fontWeight: 700 }}>{p.n}</span>
                <div>
                  <h3 className="font-display text-[26px] mb-3 leading-tight" style={{ color: "#100c0a", fontWeight: 400 }}>{p.t}</h3>
                  <p className="text-[15.5px] leading-relaxed" style={{ color: "#3a3630" }}>{p.d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="hm-container py-28">
        <p className="hm-eyebrow mb-6">Founders</p>
        <h2 className="font-display max-w-4xl leading-[1.05] tracking-[-0.01em]" style={{ fontSize: "clamp(32px, 4.2vw, 58px)", fontWeight: 400 }}>
          Three principals. 65+ years of combined work across London and the Middle East.
        </h2>

        <div className="grid md:grid-cols-3 gap-10 mt-16">
          {founders.map((f, i) => (
            <div key={f.name} className="border-t border-[color:var(--hm-line)] pt-6" data-testid={`founder-card-${i}`}>
              <p className="hm-eyebrow mb-3">{f.role}</p>
              <h3 className="font-display text-[30px] mb-4" style={{ fontWeight: 400 }}>{f.name}</h3>
              <p className="text-[color:var(--hm-ink-dim)] leading-relaxed text-[15px]">{f.bio}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
